import { createReducer } from '@reduxjs/toolkit';
import { addToLocalBasket, removeFromLocalBasket } from '../actions/basketActions';

const initialState = {
  localBasket: (() => {
    try {
      const data = JSON.parse(localStorage.getItem('basket'));
      return Array.isArray(data) ? data : [];
    } catch {
      return [];
    }
  })(),
};

export default createReducer(initialState, (builder) => {
  builder.addCase(addToLocalBasket, (state, action) => {
    const newItem = action.payload;
    return {
      ...state,
      localBasket: [...state.localBasket, newItem],
    };
  })
    .addCase(removeFromLocalBasket, (state, action) => {
      const id = action.payload;
      return {
        ...state,
        localBasket: state.localBasket.filter((item) => +item.id !== +id),
      };
    });
});
